import { css } from 'styled-components'

/**
 * The card-detail tab's nav-link treatment (EX-40737).
 *
 * `LinkText` hardcodes `text-decoration-line: underline` with no prop to turn it
 * off, and the design's text links (`.gf-textlink` in the design render) carry
 * no underline at rest — they underline on hover only. This restores that.
 *
 * Applied on `StatNavLink` rather than per consumer so every link on the tab —
 * the stats roll-up's three, recent transactions' "view all", and the budget
 * table's — moves together. They are one idiom; styling them one at a time is
 * how three of them end up looking different from the fourth.
 *
 * `&&` doubles this class's specificity so it beats the primitive's own rule.
 * Both are single-class selectors on the same element, so without it the winner
 * is decided by stylesheet injection order — a coin flip.
 */
export const navLink = css`
  && {
    text-decoration-line: none;
  }

  &&:hover {
    text-decoration-line: underline;
  }
`
